import React from 'react'
import SliderContainer from '../SliderContainer'
import Card from '../Card'

export default class FrontPage extends React.Component {
  render() {
    const firstBoxesColLength = 2
    const content = this.props.content
    return (
      <div className="frontpage-container">
        <SliderContainer
          content={content.acf.hero}
          continues={content.acf.hero.length <= 2 ? false : true}
          position="top-left"
          padding={true}
        />
        <div className="first-col">
          {content.acf.boxes.map((a, i) => {
            return i <= firstBoxesColLength ? <Card content={a} key={i} /> : ''
          })}
        </div>
        <div className="second-col">
          {content.acf.boxes.map((a, i) => {
            return i > firstBoxesColLength ? <Card content={a} key={i} /> : ''
          })}
        </div>
        <SliderContainer
          content={content.acf.slides}
          continues={content.acf.slides.length <= 2 ? false : true}
          position="top-left"
        />
      </div>
    )
  }
}
